"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var baseFormTheme = require("../../styles/baseForm.scss");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var components_1 = require("./components");
var components_2 = require("../../components");
var utils_1 = require("../../utils");
var mobx_react_1 = require("mobx-react");
var UserScope = mobx_react_1.observer(components_2.UserScope);
var Credentials = /** @class */ (function (_super) {
    tslib_1.__extends(Credentials, _super);
    function Credentials(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onEditUser = function (user) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setEditUser(user);
        };
        _this.toggleInviteModal = function () {
            _this.setState({
                showInviteModal: !_this.state.showInviteModal,
                inviteEmail: "",
                inviteRoles: [],
                inviteOrganization: ""
            });
        };
        _this.onDeleteUser = function (user) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setPendingDeleteUser(user);
        };
        _this.onUnblock = function (user) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.unblockUser(user);
        };
        _this.onDeleteInvite = function (invite) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setPendingDeleteInvite(invite);
        };
        _this.dismissDeleteUser = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setPendingDeleteUser(null);
        };
        _this.confirmDeleteUser = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.deletePendingUser();
        };
        _this.dismissDeleteInvite = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setPendingDeleteInvite(null);
        };
        _this.confirmDeleteInvite = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.deletePendingInvite();
        };
        _this.dismissEditUser = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.setEditUser(null);
        };
        _this.onToggleRole = function (e) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            accountCredentialsStore.toggleUserRole(accountCredentialsStore.editUser, e.target.name, utils_1.normalizeEventValue(e));
        };
        _this.isUserRoleEnabled = function (roleId) {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            if (!accountCredentialsStore.editUser) {
                return false;
            }
            return !!accountCredentialsStore.editUser.scopes[0].roles.find(function (role) { return role._id === roleId; });
        };
        _this.onInviteEmailChange = function (e) {
            _this.setState({
                inviteEmail: e.target.value
            });
        };
        _this.onInvite = function () {
            var accountCredentialsStore = _this.props.accountCredentialsStore;
            var _a = _this.state, inviteEmail = _a.inviteEmail, inviteRoles = _a.inviteRoles, inviteOrganization = _a.inviteOrganization;
            accountCredentialsStore.sendInvitation(inviteEmail, inviteRoles, inviteOrganization);
            _this.toggleInviteModal();
        };
        _this.onRemoveInviteRole = function (roleId) {
            _this.setState({
                inviteRoles: _this.state.inviteRoles.filter(function (x) { return x !== roleId; })
            });
        };
        _this.onSelectInviteRole = function (roleId) {
            _this.setState({
                inviteRoles: _this.state.inviteRoles.concat([roleId])
            });
        };
        _this.onSelectInviteOrganization = function (e) {
            _this.setState({
                inviteOrganization: e.target.value
            });
            _this.checkEmailAndOrganizationTheSame();
        };
        _this.checkEmailAndOrganizationTheSame = function () {
            var _a = _this.state, inviteEmail = _a.inviteEmail, inviteOrganization = _a.inviteOrganization;
            var _b = _this.props.accountCredentialsStore, isVidazooOrganization = _b.isVidazooOrganization, indexOrganizations = _b.indexOrganizations;
            if (isVidazooOrganization && inviteOrganization && !inviteEmail.includes(indexOrganizations[inviteOrganization].name)) {
                return false;
            }
            return true;
        };
        _this.state = {
            showInviteModal: false,
            inviteEmail: "",
            inviteRoles: [],
            inviteOrganization: "",
        };
        _this.initialize();
        return _this;
    }
    Credentials.prototype.initialize = function () {
        var _a = this.props, accountCredentialsStore = _a.accountCredentialsStore, accountId = _a.accountId;
        accountCredentialsStore.reset();
        accountCredentialsStore.initialize(accountId);
    };
    Credentials.prototype.renderLoader = function () {
        return (React.createElement("div", { className: baseFormTheme.message },
            React.createElement(ui_1.Loader, { size: 1, gray: true, className: baseFormTheme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading Credentials", description: "Please wait..." })));
    };
    Credentials.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.PageMessage, { small: true, title: "Failed to load Credentials", description: "We had an error loading the requested credentials.", iconName: "icon-rejected-status" })));
    };
    Credentials.prototype.renderUsers = function () {
        var _this = this;
        var accountCredentialsStore = this.props.accountCredentialsStore;
        return (React.createElement("div", null,
            React.createElement("div", { className: baseFormTheme.header },
                React.createElement(ui_1.Label, { size: 13, weight: 700, spacing: 1.25, monserrat: true }, "Users")),
            React.createElement("div", null, !accountCredentialsStore.users.length ? React.createElement(ui_1.PageMessage, { className: theme.empty, small: true, title: "No Users", description: "Invite users to this account first" }) : (React.createElement(ui_1.Table, { fill: true },
                React.createElement(ui_1.TableBody, { itemHeight: 47 }, accountCredentialsStore.users.map(function (user) { return React.createElement(components_1.UserRow, { user: user, key: user._id, onEdit: _this.onEditUser, onUnblock: _this.onUnblock, onDelete: _this.onDeleteUser }); })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement(ui_1.TableHeaderColumn, { label: "Name" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Email" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Organization" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Roles" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Actions" }))))))));
    };
    Credentials.prototype.renderInvitations = function () {
        var _this = this;
        var accountCredentialsStore = this.props.accountCredentialsStore;
        return (React.createElement("div", null,
            React.createElement("div", { className: baseFormTheme.header },
                React.createElement(ui_1.Label, { size: 13, weight: 700, spacing: 1.25, monserrat: true }, "Pending Invites"),
                React.createElement(ui_1.Button, { iconName: "icon-plus-small", medium: true, blue: true, outline: true, onClick: this.toggleInviteModal }, "Invite")),
            React.createElement("div", null, !accountCredentialsStore.invitations.length ? React.createElement(ui_1.PageMessage, { className: theme.empty, small: true, title: "No Pending Invites", description: "Click Invite to invite a new user" }) : (React.createElement(ui_1.Table, { fill: true },
                React.createElement(ui_1.TableBody, { itemHeight: 47 }, accountCredentialsStore.invitations.map(function (invite) {
                    return React.createElement(components_1.PendingInviteRow, { invite: invite, key: invite._id, onDelete: _this.onDeleteInvite });
                })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement(ui_1.TableHeaderColumn, { label: "Email" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Organization" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Roles" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Actions" }))))))));
    };
    Credentials.prototype.renderDeleteUserMessage = function () {
        var accountCredentialsStore = this.props.accountCredentialsStore;
        var pendingDeleteUser = accountCredentialsStore.pendingDeleteUser;
        return (React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.dismissDeleteUser, isOpen: pendingDeleteUser },
            React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Delete User?", text: React.createElement("span", null,
                    "Are you sure you want to delete ",
                    React.createElement(ui_1.Label, { weight: 600, uppercase: false, block: false }, pendingDeleteUser && pendingDeleteUser.email),
                    "?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.dismissDeleteUser, onConfirmClick: this.confirmDeleteUser })));
    };
    Credentials.prototype.renderDeleteInviteMessage = function () {
        var accountCredentialsStore = this.props.accountCredentialsStore;
        var pendingDeleteInvite = accountCredentialsStore.pendingDeleteInvite;
        return (React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.dismissDeleteInvite, isOpen: pendingDeleteInvite },
            React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Delete Invitation?", text: React.createElement("span", null,
                    "Are you sure you want to delete ",
                    React.createElement(ui_1.Label, { weight: 600, uppercase: false, block: false }, pendingDeleteInvite && pendingDeleteInvite.email),
                    "?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.dismissDeleteInvite, onConfirmClick: this.confirmDeleteInvite })));
    };
    Credentials.prototype.renderInviteModal = function () {
        var _a = this.props, accountCredentialsStore = _a.accountCredentialsStore, isInRoles = _a.isInRoles;
        var isLoading = accountCredentialsStore.isLoading, organizations = accountCredentialsStore.organizations, isVidazooOrganization = accountCredentialsStore.isVidazooOrganization;
        var _b = this.state, showInviteModal = _b.showInviteModal, inviteRoles = _b.inviteRoles, inviteEmail = _b.inviteEmail, inviteOrganization = _b.inviteOrganization;
        return (React.createElement(ui_1.Modal, { panel: true, title: "Invite user", scrollableContent: false, exitOnClickOutside: false, onClose: this.toggleInviteModal, isOpen: showInviteModal, windowStyle: { width: 600 } },
            React.createElement("div", { className: theme.modal },
                React.createElement(ui_1.Form, { className: baseFormTheme.form, onSubmit: this.onInvite },
                    React.createElement("div", { className: baseFormTheme.row },
                        React.createElement(ui_1.FormInput, { type: "email", onChange: this.onInviteEmailChange, value: inviteEmail, label: "Email", required: true, fill: true })),
                    React.createElement("div", { className: baseFormTheme.row },
                        React.createElement(ui_1.FormChips, { fill: true, required: true, label: "Access Roles", chips: inviteRoles, dataSource: accountCredentialsStore.roles.map(function (role) { return ({
                                value: role._id,
                                label: role.name
                            }); }), onDelete: this.onRemoveInviteRole, onSelect: this.onSelectInviteRole })),
                    isVidazooOrganization ? (React.createElement("div", { className: baseFormTheme.row },
                        React.createElement(ui_1.FormSelect, { label: "Organization", placeholder: "select organization", required: true, items: organizations, itemValueKey: "_id", itemLabelKey: "name", isLoading: isLoading, value: inviteOrganization, onChange: this.onSelectInviteOrganization, fill: true, searchable: true, maxItems: 5 }))) : null,
                    (!this.checkEmailAndOrganizationTheSame()) ? (React.createElement("div", { className: baseFormTheme.row },
                        React.createElement(ui_1.Attention, { label: "The email does not contain the organization", orange: true }))) : null,
                    React.createElement("div", { className: baseFormTheme.actions },
                        React.createElement(ui_1.Button, { type: "submit", blue: true, medium: true, uppercase: true }, "Send Invite"))))));
    };
    Credentials.prototype.renderEditUserModal = function () {
        var _this = this;
        var accountCredentialsStore = this.props.accountCredentialsStore;
        var editUser = accountCredentialsStore.editUser, roles = accountCredentialsStore.roles;
        return (React.createElement(ui_1.Modal, { exitOnClickOutside: true, panel: true, title: "Edit User Roles", isOpen: editUser, onClose: this.dismissEditUser, windowStyle: { width: 500 } }, editUser ? (React.createElement("div", { className: theme.modal },
            React.createElement(ui_1.Label, { weight: 600, uppercase: false, block: false },
                editUser.firstName,
                " ",
                editUser.lastName,
                "'s Access Roles"),
            React.createElement("ul", { className: theme.rolesList }, roles.map(function (role) {
                return React.createElement("li", { key: role._id },
                    React.createElement(ui_1.Checkbox, { label: role.name, name: role._id, checked: _this.isUserRoleEnabled(role._id), onChange: _this.onToggleRole }));
            })))) : null));
    };
    Credentials.prototype.renderForm = function () {
        var accountCredentialsStore = this.props.accountCredentialsStore;
        return (React.createElement(React.Fragment, null,
            this.renderUsers(),
            React.createElement(ui_1.HLine, null),
            this.renderInvitations(),
            this.renderDeleteUserMessage(),
            this.renderDeleteInviteMessage(),
            this.renderInviteModal(),
            this.renderEditUserModal()));
    };
    Credentials.prototype.render = function () {
        var accountCredentialsStore = this.props.accountCredentialsStore;
        return (React.createElement("div", { className: baseFormTheme.form },
            accountCredentialsStore.isLoading ? this.renderLoader() : null,
            accountCredentialsStore.loadError ? this.renderError() : null,
            !accountCredentialsStore.isLoading && !accountCredentialsStore.loadError ? this.renderForm() : null));
    };
    Credentials.defaultProps = {};
    return Credentials;
}(React.Component));
exports.default = Credentials;
